import styled from 'styled-components';

export const InnerStyle = styled.div`
  background-color: ${(props) => props.color};
  height: 8px;
  width: 8px;
  border-radius: 50%;
`;

export const OuterStyle = styled.div<{ color: string; hover: boolean }>`
  background-color: ${(props) => props.color};
  height: 30px;
  width: 30px;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    height: 100%;
    width: auto;
  }

  &:hover {
    cursor: ${(props) => (props.hover ? 'pointer' : 'default')};
  }
`;
